import { render, staticRenderFns } from "./SummaryTablePage.vue?vue&type=template&id=20dd15eb&scoped=true&"
import script from "./SummaryTablePage.vue?vue&type=script&lang=js&"
export * from "./SummaryTablePage.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTablePage.vue?vue&type=style&index=0&id=20dd15eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd15eb",
  null
  
)

export default component.exports